export function Logout(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9126 1.19922C14.0502 1.19922 14.9798 2.08961 15.0425 3.21149L15.0459 3.33255V12.6659C15.0459 13.8035 14.1555 14.7331 13.0336 14.7958L12.9126 14.7992H10.2459C9.80409 14.7992 9.44592 14.441 9.44592 13.9992C9.44592 13.585 9.76072 13.2443 10.1641 13.2033L10.2459 13.1992H12.9126C13.1845 13.1992 13.4089 12.9958 13.4418 12.7328L13.4459 12.6659V3.33255C13.4459 3.06066 13.2425 2.83628 12.9795 2.80337L12.9126 2.79922H10.2459C9.80409 2.79922 9.44592 2.44105 9.44592 1.99922C9.44592 1.58501 9.76072 1.24432 10.1641 1.20335L10.2459 1.19922H12.9126Z"
          fill="currentColor"
        />
        <path
          d="M9.83963 8.79922L7.97185 10.9786L7.91868 11.0478C7.69081 11.3804 7.74552 11.8383 8.05862 12.1066C8.39408 12.3942 8.89912 12.3553 9.18666 12.0199L11.8148 8.95371L11.8889 8.85984C12.2841 8.31521 12.2594 7.56346 11.8148 7.04472L9.18666 3.97859L9.12637 3.91546C8.83254 3.6394 8.37172 3.62344 8.05862 3.89181C7.72316 4.17935 7.68431 4.68439 7.97185 5.01985L9.83963 7.19922H1.75386L1.67206 7.20335C1.26866 7.24432 0.953857 7.58501 0.953857 7.99922C0.953857 8.44105 1.31203 8.79922 1.75386 8.79922H9.83963Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
